import { TbFileText, TbLayoutBoard, TbShare2 } from "solid-icons/tb";
import type { Component, JSX } from "solid-js";
import { Dynamic } from "solid-js/web";
import { useI18n } from "~/i18n";
import type { TranslationKey } from "~/i18n/translations";
import { CollabCanvas, type CollabData, CollabDocuments, CollabShare } from "./internal/CollabScenes";
import { SceneTabs } from "./internal/SceneTabs";

export type MultiplayerData = CollabData;

type View = {
  tab: TranslationKey;
  alt: TranslationKey;
  icon: typeof TbShare2;
  scene: (props: { data: CollabData; label: string }) => JSX.Element;
};

const VIEWS: View[] = [
  {
    tab: "marketing.mock.collab.tab_canvas",
    alt: "marketing.mock.collab.alt_canvas",
    icon: TbLayoutBoard,
    scene: CollabCanvas,
  },
  {
    tab: "marketing.mock.collab.tab_documents",
    alt: "marketing.mock.collab.alt_documents",
    icon: TbFileText,
    scene: CollabDocuments,
  },
  {
    tab: "marketing.mock.collab.tab_share",
    alt: "marketing.mock.collab.alt_share",
    icon: TbShare2,
    scene: CollabShare,
  },
];

/**
 * A shared live session across its three surfaces: sketching on the canvas,
 * writing the doc alongside Chief, and sharing a link anyone can follow.
 */
export const MultiplayerMockup: Component<{ data: MultiplayerData }> = (props) => {
  const { t } = useI18n();
  return (
    <SceneTabs
      items={VIEWS}
      label={t("marketing.mock.collab.tabs_label")}
      tab={(view) => (
        <>
          <view.icon class="size-4" aria-hidden="true" />
          {t(view.tab)}
        </>
      )}
    >
      {(view) => <Dynamic component={view.scene} data={props.data} label={t(view.alt)} />}
    </SceneTabs>
  );
};
